import { redirect } from "react-router-dom";
import Config from "../config.json";
import { ActionResponse, ErrorResponse, Dependence } from "../interfaces/type";
import toast from "react-hot-toast";

const TOKEN = localStorage.getItem("token");

export const getPlaceDependence = async (): Promise<string[]> => {
  const response = await fetch(`${Config.API_URL}/dependence/getPlace`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${TOKEN}`,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch comments.");
  }

  const res = await response.json();
  if (response.status === 401) {
    redirect("/");
  }

  if (res.status === 500) {
    let error = res as ErrorResponse;
    toast.error(`${error.error} - ${error.errorDetail}`);
  }
  return res?.data ?? [];
};

export const getDependence = async (): Promise<Partial<Dependence>[]> => {
  const response = await fetch(`${Config.API_URL}/dependence`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${TOKEN}`,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch comments.");
  }

  const res = await response.json();
  if (response.status === 401) {
    redirect("/");
  }

  if (res.status === 500) {
    let error = res as ErrorResponse;
    toast.error(`${error.error} - ${error.errorDetail}`);
  }
  return res?.data ?? [];
};

export const addDependenceService = async (
  data: Partial<Dependence>,
  token: String
): Promise<Partial<ActionResponse | ErrorResponse>> => {
  const response = await fetch(`${Config.API_URL}/dependence`, {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const res = await response.json();
  return res;
};

export const editDependenceService = async (
  data: Partial<Dependence>,
  token: String
): Promise<Partial<ActionResponse | ErrorResponse>> => {
  const response = await fetch(`${Config.API_URL}/dependence/${data.id}`, {
    method: "PUT",
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const res = await response.json();
  if (response.status === 401) {
    redirect("/");
  }

  if (res.status === 500) {
    let error = res as ErrorResponse;
    toast.error(`${error.error} - ${error.errorDetail}`);
  }
  return res;
};

export const deleteDependenceService = async (
  id: string,
  token: String
): Promise<Partial<ActionResponse | ErrorResponse>> => {
  const response = await fetch(`${Config.API_URL}/dependence/${id}`, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const res = await response.json();
  if (response.status === 401) {
    redirect("/");
  }

  if (res.status === 500) {
    let error = res as ErrorResponse;
    toast.error(`${error.error} - ${error.errorDetail}`);
  }
  return res;
};

export const getDependenceByUser = async (): Promise<Partial<Dependence>[]> => {
  const response = await fetch(`${Config.API_URL}/dependence/getDependenceByUser`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${TOKEN}`,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch comments.");
  }

  const res = await response.json();
  if (response.status === 401) {
    redirect("/");
  }

  if (res.status === 500) {
    let error = res as ErrorResponse;
    toast.error(`${error.error} - ${error.errorDetail}`);
  }
  return res?.data ?? [];
};
